export const STORIES_REPORT_KEYS = ["news_views", "views_unique_users", "news_opens", "opens_unique_users"];
